<template lang="pug">
.filtersComponent
  .info-filters

    section.level
      .title Класс
      ui-dropdown-select.dropdown(
        is-responsive
        v-model="selectedLevel"
        :options="levelOptions"
        placeholderText="Все классы"
      )

    section.type
      .title Тип
        ui-checkbox-select(
          v-model="selectedTypes"
          :options="typeOptions"
          :is-multiple="true"
          :allow-empty="true"
        )

    section.subject
      .title Предмет
      ui-loader(v-if="isLoading")
      template(v-else)
        ui-checkbox-select(
          v-model="selectedSubjects"
          :options="subjectOptions"
          :is-multiple="true"
          :allow-empty="true"
        )

  .reset-wrap
    ui-button.reset(
      @click="$emit('action:reset')"
      color="blue-outline"
    ) Сбросить фильтры
</template>

<script>
import SubjectController from '@/controllers/SubjectController'
import { USER_ITEM_TYPE_BOOK, USER_ITEM_TYPE_VPR } from '@/config'
export default {
  props: {
    selectedLevel: {
      type: Number,
      default: null
    },
    selectedTypes: {
      type: Array,
      default: () => []
    },
    selectedSubjects: {
      type: Array,
      default: () => []
    }
  },
  emits: ['action:reset', 'update:selectedLevel', 'update:selectedTypes', 'update:selectedSubjects'],
  setup () {
    const { subjects, requestSubjects, isLoading } = SubjectController()
    requestSubjects()
    return { subjectOptions: subjects, requestSubjects, isLoading }
  },
  computed: {
    levelOptions () {
      const items = [0, 1, 2, 3, 4].map(g => ({
        value: g,
        label: g === 0 ? 'Подготовительный класс' : g + ' класс'
      }))

      items.unshift({ value: null, label: 'Все классы' })

      return items
    },
    typeOptions () {
      return [
        { id: USER_ITEM_TYPE_VPR, label: 'Подготовка к ВПР' },
        { id: USER_ITEM_TYPE_BOOK, label: 'Домашние занятия' }
      ]
    }
  },
  watch: {
    selectedLevel (value) {
      this.$emit('update:selectedLevel', value)
    },
    selectedTypes (value) {
      this.$emit('update:selectedTypes', value)
    },
    selectedSubjects (value) {
      this.$emit('update:selectedSubjects', value)
    }
  }
}
</script>

<style lang="sass" scoped>
.filtersComponent
  background: $cWhite
  padding: 7.5*$u
  height: fit-content
  width: 83*$u

  > .info-filters
    display: flex
    flex-flow: column
    @include gap(7.5*$u, 'column')
    @media (max-width: $padWidth)
      max-width: 60*$u

    > section
      > .title
        @include font('h3')
      > .dropdown
        margin-top: 4*$u

      > .checkbox-subjects
        display: flex
        align-items: center
        gap: 4*$u

  > .reset-wrap
    padding-top: 10*$u
    .reset
      min-width: 46.5*$u

  @media screen and (max-width: $padWidth)
    .reset
      @include fix-old-browsers
        margin-bottom: 13.5*$u

</style>
